import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RevenueReport, TCaClickUsage, TCashReport, TCashReportsData, TMosSubscription, TOpenTradeReportsData, WalletReport, CashOutStandingReport, TRadeOverviewReport, TradeLoanData, CashRecoveryReport, ActiveCustomersData, TDailySummary, TRadeTimelineReport, TAllTradeDetails, CashOverviewReport, EmpBusiSmry, WalletBalances, TSubscriberReport } from "../types";
import { TCalendarType } from "../components/commons/ono-calendar-v2/calendar_types";
import moment from "moment";

export type Calander = {
  fromDate: string;
  toDate: string;
  mode: TCalendarType;
}

const now = new Date();

const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

type TinitialState = {
  activeTab: string;
  filteredTraders: any[];
  openFilteredTraders: any[];
  allTradeFilteredTraders: TAllTradeDetails[];
  excessPaymentFilter: any[];
  gstReconciliationFilter: any[];
  onoOutStandBalFilter: any[];
  employeeAttendanceFilter: any[];
  allReportsData: TCashReportsData[];
  openTradeReports: TOpenTradeReportsData[]
  srcPmtTermFilter: string[];
  destPmtTermFilter: string[];
  statusFilter: string[];
  mosSubscriptionFee: TMosSubscription[];
  mosSubscriptionFilter: any[];
  tradeCashDetailsFilter: TradeLoanData[];
  cashRecoveryReportFilter: any[];
  caClickUsage: TCaClickUsage[];
  caClickUsageFilter: any[];
  cashReportData: TCashReport[];
  cashReportFilter: any[];
  walletReportData: WalletReport[];
  walletReportFilter: any[];
  revenueReportData: RevenueReport[];
  revenueReportFilter: any[];
  activeCustomersFilter: ActiveCustomersData | null;
  cashOutStandingReportData: CashOutStandingReport[];
  cashOutStandingReportFilter: any[];
  cashOutSearch: string;
  tradeOverviewData: TRadeOverviewReport[];
  searchReportsData: string;
  isLoading: boolean;
  calenderDate: Calander;
  dateChange: boolean;
  openStatusFilter: boolean;
  open: boolean;
  localSelectedStatus: string[];
  selectStatus: string[];

  statusSelect: string[];

  destPmtTermSelect: string[];
  destPmtTermOpen: boolean;

  srcPmtTermSelect: string[];
  srcPmtTermOpen: boolean;
  dailyBusinessReportFilter: TDailySummary[];
  tradeOutstandReportFilter: any[];
  cashRecoveryData: CashRecoveryReport | null;
  mainTabs: string;
  tradeTimelinesData: TRadeTimelineReport[];
  filterTradeTimelines: TRadeTimelineReport[];
  cashOverview: CashOverviewReport | null;
  empBusnSmryFilter: EmpBusiSmry[];

  walletBalancesFilter: WalletBalances[];

  subscriberOverview: TSubscriberReport[];
  subscriberOverviewFilter: TSubscriberReport[];
  subscriberStatus: string[];
};
const initialState: TinitialState = {
  activeTab: "creditDebitReports",
  filteredTraders: [],
  openFilteredTraders: [],
  allTradeFilteredTraders: [],
  excessPaymentFilter: [],
  employeeAttendanceFilter: [],
  allReportsData: [],
  srcPmtTermFilter: [],
  destPmtTermFilter: [],
  statusFilter: [],
  gstReconciliationFilter: [],
  onoOutStandBalFilter: [],
  mosSubscriptionFee: [],
  mosSubscriptionFilter: [],
  caClickUsage: [],
  caClickUsageFilter: [],
  openTradeReports: [],
  cashReportData: [],
  cashReportFilter: [],
  walletReportData: [],
  walletReportFilter: [],
  revenueReportData: [],
  revenueReportFilter: [],
  cashOutStandingReportData: [],
  cashOutStandingReportFilter: [],
  cashOutSearch: "",
  tradeOverviewData: [],
  searchReportsData: "",
  isLoading: false,
  calenderDate: {
    fromDate: "",
    toDate: "",
    mode: "ALL"
  },
  dateChange: false,
  openStatusFilter: false,
  open: false,
  localSelectedStatus: [],
  selectStatus: [],
  statusSelect: [],
  destPmtTermSelect: [],
  destPmtTermOpen: false,
  srcPmtTermSelect: [],
  srcPmtTermOpen: false,
  dailyBusinessReportFilter: [],
  tradeOutstandReportFilter: [],
  cashRecoveryReportFilter: [],
  tradeCashDetailsFilter: [],
  cashRecoveryData: null,
  activeCustomersFilter: null,
  mainTabs: "operations",
  tradeTimelinesData: [],
  filterTradeTimelines: [],
  cashOverview: null,
  empBusnSmryFilter: [],
  walletBalancesFilter: [],
  subscriberOverview: [],
  subscriberOverviewFilter: [],
  subscriberStatus: []
};
const reportsSlice = createSlice({
  name: "reports",
  initialState: initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<string>) => {
      state.activeTab = action.payload;
    },
    setFilteredTraders(state, action: PayloadAction<any[]>) {
      state.filteredTraders = action.payload;
    },
    setOpenFilteredTraders(state, action: PayloadAction<any[]>) {
      state.openFilteredTraders = action.payload;
    },
    setAllFilteredTraders(state, action: PayloadAction<any[]>) {
      state.allTradeFilteredTraders = action.payload;
    },
    setExcessFilter(state, action: PayloadAction<any[]>) {
      state.excessPaymentFilter = action.payload;
    },
    setGstReconciliationFilter(state, action: PayloadAction<any[]>) {
      state.gstReconciliationFilter = action.payload;
    },
    setEmployeeFilter(state, action: PayloadAction<any[]>) {
      state.employeeAttendanceFilter = action.payload;
    },
    setAllReportsData: (state, action: PayloadAction<TCashReportsData[]>) => {
      state.allReportsData = action.payload;
    },
    setOpenTradeReports: (state, action: PayloadAction<TOpenTradeReportsData[]>) => {
      state.openTradeReports = action.payload;
    },
    setSrcPmtTermFilter: (state, action: PayloadAction<string[]>) => {
      state.srcPmtTermFilter = action.payload;
    },
    setDestPmtTermFilter: (state, action: PayloadAction<string[]>) => {
      state.destPmtTermFilter = action.payload;
    },
    setStatusFilter: (state, action: PayloadAction<string[]>) => {
      state.statusFilter = action.payload;
    },
    setMosSubscriptionFees: (
      state,
      action: PayloadAction<TMosSubscription[]>
    ) => {
      state.mosSubscriptionFee = action.payload;
    },
    setMosSubscriptionFilter(state, action: PayloadAction<any[]>) {
      state.mosSubscriptionFilter = action.payload;
    },
    setCaClickUsage(state, action: PayloadAction<TCaClickUsage[]>) {
      state.caClickUsage = action.payload
    },
    setCaClickUsageFilter(state, action: PayloadAction<any[]>) {
      state.caClickUsageFilter = action.payload;
    },
    setCashReportData: (state, action: PayloadAction<TCashReport[]>) => {
      state.cashReportData = action.payload;
    },
    setCashReportFilter(state, action: PayloadAction<any[]>) {
      state.cashReportFilter = action.payload;
    },
    setWalletReportData: (state, action: PayloadAction<WalletReport[]>) => {
      state.walletReportData = action.payload;
    },
    setWalletReportFilter(state, action: PayloadAction<any[]>) {
      state.walletReportFilter = action.payload;
    },
    setRevenueReportData: (state, action: PayloadAction<RevenueReport[]>) => {
      state.revenueReportData = action.payload;
    },
    setRevenueReportFilter(state, action: PayloadAction<any[]>) {
      state.revenueReportFilter = action.payload;
    },
    setcashOutStandingReportData: (state, action: PayloadAction<CashOutStandingReport[]>) => {
      state.cashOutStandingReportData = action.payload;
    },
    setcashOutStandingReportFilter(state, action: PayloadAction<any[]>) {
      state.cashOutStandingReportFilter = action.payload;
    },
    setCashOutSearch: (state, action: PayloadAction<string>) => {
      state.cashOutSearch = action.payload
    },
    setTradeOverviewData: (state, action: PayloadAction<TRadeOverviewReport[]>) => {
      state.tradeOverviewData = action.payload
    },
    setSearchReportsData: (state, action: PayloadAction<string>) => {
      state.searchReportsData = action.payload
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setCalenderDate: (state, action: PayloadAction<Calander>) => {
      state.calenderDate = action.payload;
    },
    setDateChange: (state, action: PayloadAction<boolean>) => {
      state.dateChange = action.payload
    },
    setOpenStatusFilter: (state, action: PayloadAction<boolean>) => {
      state.openStatusFilter = action.payload;
    },
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
    setLocalSelectedStatus: (state, action: PayloadAction<string[]>) => {
      state.localSelectedStatus = action.payload;
    },
    setSelectStatus: (state, action: PayloadAction<string[]>) => {
      state.selectStatus = action.payload;
    },
    setStatusSelect: (state, action: PayloadAction<string[]>) => {
      state.statusSelect = action.payload;
    },
    setDestPmtTermSelect: (state, action: PayloadAction<string[]>) => {
      state.destPmtTermSelect = action.payload;
    },
    setDestPmtTermOpen: (state, action: PayloadAction<boolean>) => {
      state.destPmtTermOpen = action.payload;
    },
    setSrcPmtTermSelect: (state, action: PayloadAction<string[]>) => {
      state.srcPmtTermSelect = action.payload;
    },
    setSrcPmtTermOpen: (state, action: PayloadAction<boolean>) => {
      state.srcPmtTermOpen = action.payload;
    },
    resetData: (state) => {
      state.searchReportsData = initialState.searchReportsData;
      state.isLoading = initialState.isLoading;
      state.calenderDate = initialState.calenderDate;
      state.dateChange = initialState.dateChange;
    },
    setDailyBusinessReportFilter: (state, action: PayloadAction<TDailySummary[]>) => {
      state.dailyBusinessReportFilter = action.payload;
    },
    setTradeOutstandReportFilter: (state, action: PayloadAction<any[]>) => {
      state.tradeOutstandReportFilter = action.payload;
    },
    setOnoOutStandBalFilter(state, action: PayloadAction<any[]>) {
      state.onoOutStandBalFilter = action.payload;
    },
    setCashRecoveryReportFilter(state, action: PayloadAction<any[]>) {
      state.cashRecoveryReportFilter = action.payload;
    },
    setTradeCashDetailsFilter: (state, action: PayloadAction<TradeLoanData[]>) => {
      state.tradeCashDetailsFilter = action.payload;
    },
    setCashRecoveryData: (state, action: PayloadAction<CashRecoveryReport | null>) => {
      state.cashRecoveryData = action.payload
    },
    setActiveCustomersFilter: (state, action: PayloadAction<ActiveCustomersData | null>) => {
      state.activeCustomersFilter = action.payload
    },
    setMainTabs: (state, action: PayloadAction<string>) => {
      state.mainTabs = action.payload
    },
    setTradeTimelinesData: (state, action: PayloadAction<TRadeTimelineReport[]>) => {
      state.tradeTimelinesData = action.payload
    },
    setFilterTradeTimelines: (state, action: PayloadAction<TRadeTimelineReport[]>) => {
      state.filterTradeTimelines = action.payload
    },
    setCashOverview: (state, action: PayloadAction<CashOverviewReport | null>) => {
      state.cashOverview = action.payload
    },
    setEmpBusnSmryFilter: (state, action: PayloadAction<EmpBusiSmry[]>) => {
      state.empBusnSmryFilter = action.payload
    },
    setWalletBalancesFilter: (state, action: PayloadAction<WalletBalances[]>) => {
      state.walletBalancesFilter = action.payload
    },
    setSubscriberOverview: (state, action: PayloadAction<TSubscriberReport[]>) => {
      state.subscriberOverview = action.payload
    },
    setSubscriberOverviewFilter: (state, action: PayloadAction<TSubscriberReport[]>) => {
      state.subscriberOverviewFilter = action.payload
    },
    setSubscriberStatus: (state, action: PayloadAction<string[]>) => {
      state.subscriberStatus = action.payload
    }
  },
});
export const {
  setActiveTab,
  setDestPmtTermSelect,
  setDestPmtTermOpen,
  setFilteredTraders,
  setSrcPmtTermSelect,
  setSrcPmtTermOpen,
  setOpenFilteredTraders,
  setAllFilteredTraders,
  setExcessFilter,
  setEmployeeFilter,
  setAllReportsData,
  setSrcPmtTermFilter,
  setDestPmtTermFilter,
  setStatusFilter,
  setGstReconciliationFilter,
  setMosSubscriptionFees,
  setMosSubscriptionFilter,
  setCaClickUsage,
  setCaClickUsageFilter,
  setOpenTradeReports,
  setCashReportData,
  setCashReportFilter,
  setWalletReportData,
  setWalletReportFilter,
  setRevenueReportData,
  setRevenueReportFilter,
  setcashOutStandingReportData,
  setcashOutStandingReportFilter,
  setCashOutSearch,
  setTradeOverviewData,
  setSearchReportsData,
  setIsLoading,
  setCalenderDate,
  setDateChange,
  setSelectStatus,
  setOpenStatusFilter,
  setOpen,
  setLocalSelectedStatus,
  setStatusSelect,
  resetData,
  setDailyBusinessReportFilter,
  setTradeOutstandReportFilter,
  setOnoOutStandBalFilter,
  setCashRecoveryReportFilter,
  setTradeCashDetailsFilter,
  setCashRecoveryData,
  setActiveCustomersFilter,
  setMainTabs,
  setTradeTimelinesData,
  setFilterTradeTimelines,
  setCashOverview,
  setEmpBusnSmryFilter,
  setWalletBalancesFilter,
  setSubscriberOverview,
  setSubscriberOverviewFilter,
  setSubscriberStatus
} = reportsSlice.actions;
export default reportsSlice.reducer;
